import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CaptureRequests from '@/containers/CaptureRequest';

export default () => (
  <Switch>
    <Route path="/capture/requests" component={CaptureRequests} />
  </Switch>
);